import { LeaderChangeType } from "../../types/commonTypes/leaderChangeType";

export const leaderChangeInitialState: LeaderChangeType = {
    change: "Nomination sans départ",
    function: "",
}